import { createSelector } from "reselect";
import { isEmpty } from "lodash";
//EXTRACT THE PART OF THE STATE
const getData = state => state.messaging.chat.user;

const getSelectedChatUser = createSelector(getData, user => user);

export default getSelectedChatUser;



// WEBPACK FOOTER //
// ./src/_selectors/messagingSelectors/getSelectedChatUser.js